<template>
  <div class="home" v-loading="loading">
    <div class="header">
      <!-- 添加区域 -->
      <div class="add" @click="addlist">
        <img class="ioc" src="../../assets/common/common-add.png" />
        <div class="addtext">添加</div>
      </div>
    </div>

    <div class="header-table">
      <el-table
        :data="tableData"
        border
        style="width: 100%; cursor: pointer"
        :header-cell-style="{
          color: '#333333',
          backgroundColor: '#FAFAFA',
        }"
      >
        <!-- 自定义暂无数据 -->
        <template slot="empty">
          <div class="empty-block">
            <img
              class="empty-block-img"
              src="../../assets/common/common-empty.png"
            />
            <div class="empty-block-text">暂无数据～</div>
          </div>
        </template>
        <el-table-column prop="name" label="标题"> </el-table-column>
        <el-table-column prop="admin_name" label="最后编辑id名称" width="240">
        </el-table-column>
        <el-table-column label="操作" width="198">
          <template slot-scope="scope">
            <div class="table-display">
              <div class="table-operation" @click="compileBtn(scope.row)">
                编辑
              </div>

              <div class="table-operation" @click="deteleBtn(scope.row)">
                删除
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--第一区域添加 弹出框-->
    <div class="addBlock">
      <el-dialog
        :visible.sync="addDialogVisible"
        width="444px"
        style="margin-top: 10vh"
        @close="addClose"
        :style="{
          '--height': additionError == false ? '2.03125rem' : '2.215rem',
        }"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addBlock-div">
            <div class="addBlock-div-top">
              <div class="addBlock-div-top-title">添加</div>
              <img
                class="addBlock-div-top-close"
                src="../../assets/common/close.png"
                @click="addClose"
              />
            </div>

            <div class="addBlock-div-error" v-if="additionError == true">
              <div class="addBlock-div-error-text">
                抱歉，标题和内容不能为空！
              </div>
            </div>

            <div class="addBlock-div-center">
              <div class="center-header">
                <div class="center-header-title">标题</div>
                <div class="center-header-input">
                  <el-input
                    placeholder="请输入标题"
                    v-model="additionTitle"
                    clearable
                  ></el-input>
                </div>
              </div>

              <div class="center-conversion">
                <div class="center-conversion-title">内容</div>
                <div class="center-conversion-input">
                  <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="additionTextarea"
                    maxlength=""
                    show-word-limit
                  ></el-input>
                </div>
              </div>
            </div>

            <div class="addBlock-div-button">
              <!-- <div class="addBlock-div-button-left" @click="addClose">
                重 置
              </div> -->
              <div class="addBlock-div-button-right" @click="addConfirm">
                确 定
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--二级确定  是否添加内容 -->
    <div class="reminder">
      <el-dialog
        :visible.sync="reminderDialogVisible"
        width="394px"
        style="margin-top: 10vh"
        @close="cancelReminder"
      >
        <span slot="footer" class="dialog-footer">
          <div class="reminder-div">
            <img
              class="reminder-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="reminder-div-title">
              是否确定{{ deteleId == '' ? '添加' : '修改' }}该帮助内容信息？
            </div>
            <div class="reminder-div-button">
              <div class="reminder-div-button-left" @click="confirmReminder">
                确定
              </div>
              <div class="reminder-div-button-right" @click="cancelReminder">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--删除 -->
    <div class="detele">
      <el-dialog
        :visible.sync="deteleDialogVisible"
        width="394px"
        style="margin-top: 10vh"
        @close="cancelDetele"
      >
        <span slot="footer" class="dialog-footer">
          <div class="detele-div">
            <img
              class="detele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="detele-div-title">是否确定删除该帮助内容？</div>
            <div class="detele-div-button">
              <div class="detele-div-button-left" @click="confirmDetele">
                确定
              </div>
              <div class="detele-div-button-right" @click="cancelDetele">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  gethelp,
  posthelpAdd,
  deletefnhelp,
  gethelpDetail,
} from '../../api/common'

export default {
  comments() {},
  data() {
    return {
      // 添加 弹出框  是否开启
      addDialogVisible: false,
      // 添加 弹出框 标题
      additionTitle: '',
      // 添加 弹出框 富文本
      additionTextarea: '',
      //  添加 弹出框 错误
      additionError: false,

      // 删除弹出框
      deteleDialogVisible: false,
      // 删除弹出框id
      deteleId: '',
      // 二级确认是否添加内容
      reminderDialogVisible: false,
      /* 查看弹出框 */
      examineDialogVisible: false,
      // 查看弹出框 对象
      examineObj: {},

      /* end */
      tableData: [],
      totalNum: 0,
      // 刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      basicFunShow: false,
    }
  },
  created() {
    this.loading = true
    this.gethelpClick()

    setTimeout(() => {
        this.basicFunShow = this.$store.state.pageFunctionShow
    }, 1000);
  },
  methods: {
    // 获取通知列表接口
    gethelpClick() {
      let params = {}

      gethelp(params).then((res) => {
        if (res.resultStatus == true) {
          console.log('获取接口返回', res)
          // 获取表格数据
          this.tableData = res.resultData.helpList
          // 获取表格总条数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },
    // 查看弹出框 开启
    compileBtn(item) {
      if (this.basicFunShow == false) {
        return
      }

      console.log('开启', item)
      let params = item.id

      gethelpDetail(params).then((res) => {
        if (res.resultStatus == true) {
          console.log('查看开启数据', res)
          this.additionTitle = res.resultData.name
          this.additionTextarea = res.resultData.content
          this.deteleId = item.id
          this.addDialogVisible = true
        }
      })
    },

    // 删除弹出框开启
    deteleBtn(item) {
      if (this.basicFunShow == false) {
        return
      }

      this.deteleId = item.id
      this.deteleDialogVisible = true
    },

    // 删除弹出框 确定
    confirmDetele() {
      let params = this.deteleId

      deletefnhelp(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '删除成功！',
            type: 'success',
          })

          this.loading = true
          this.deteleDialogVisible = false
          this.gethelpClick()
        }
      })
    },
    // 删除弹出框 取消
    cancelDetele() {
      this.deteleId = ''
      this.deteleDialogVisible = false
    },

    // 添加弹出框 开启
    addlist() {
      if (this.basicFunShow == false) {
        return
      }

      this.additionError = false
      this.additionTitle = ''
      this.additionTextarea = ''
      this.deteleId = ''
      this.addDialogVisible = true
    },
    // 添加弹出框 确认
    addConfirm() {
      // 弹出二级确认
      if (this.additionTitle != '' && this.additionTextarea != '') {
        this.reminderDialogVisible = true
      } else {
        this.additionError = true
      }
    },
    // 添加弹出框 重置
    addClose() {
      this.deteleId = ''
      this.addDialogVisible = false
    },

    // 添加二级确认 确定
    confirmReminder() {
      let params = {
        id: this.deteleId, // id
        name: this.additionTitle, // 通知标题
        content: this.additionTextarea, // 通知内容
      }

      posthelpAdd(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '添加成功！',
            type: 'success',
          })

          this.loading = true
          this.addDialogVisible = false
          this.reminderDialogVisible = false
          this.gethelpClick()
        } else {
          this.additionError = true
        }
      })
    },
    // 添加二级确认  取消
    cancelReminder() {
      this.deteleId, // id
        (this.addDialogVisible = false)
      this.reminderDialogVisible = false
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.home {
  margin: 0 auto;
  background-color: #f4f5f9;
  min-height: 900px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #edeff7;
  border-radius: 10px;
}
.header {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;

  .add {
    width: 82px;
    height: 36px;
    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .ioc {
      width: 13px;
      height: 13px;
    }
    .addtext {
      margin-left: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.header-table {
  padding: 0 24px;
  box-sizing: border-box;
  /deep/ .el-table thead {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    background: #d8d8d8;
  }

  /deep/ .el-table tr {
    height: 46px;
  }

  /deep/ .el-table__empty-text {
    line-height: 0;
  }

  .empty-block {
    margin-top: 62px;
    padding-bottom: 40px;
    .empty-block-img {
      width: 130px;
      height: 130px;
      margin: 0 auto;
    }

    .empty-block-text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-top: 10px;
      height: 17px;
      line-height: 17px;
    }
  }

  .table-display {
    display: flex;
    .table-operation {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2aa4ff;
      text-decoration: underline;
    }

    .table-operation:nth-child(2) {
      margin-left: 24px;
    }
  }
}

// 添加
.addBlock {
  /deep/ .el-dialog {
    height: var(--height) !important;
    border-radius: 10px !important;
  }

  /deep/ .el-dialog__footer {
    padding: 0;
    text-align: left;
  }
  .addBlock-div {
    .addBlock-div-top {
      display: flex;
      height: 56px;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      box-sizing: border-box;
      border-bottom: 1px solid #e9edf4;
      .addBlock-div-top-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
      }
      .addBlock-div-top-close {
        width: 10px;
        height: 10px;
        cursor: pointer;
      }
    }

    .addBlock-div-error {
      display: flex;
      height: 30px;
      align-items: center;
      padding: 0 24px;
      box-sizing: border-box;
      background: rgba(249, 182, 60, 0.1);
      .addBlock-div-error-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ed6d1f;
      }
    }

    .addBlock-div-center {
      padding: 20px 24px 21px;
      box-sizing: border-box;
      .center-header {
        .center-header-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .center-header-input {
          height: 32px;
          background: #ffffff;
          border-radius: 5px;
          margin-top: 4px;

          /deep/ .el-input {
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }
        }
      }

      .center-conversion {
        margin-top: 14px;

        .center-conversion-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .center-conversion-input {
          background: #ffffff;
          border-radius: 5px;
          margin-top: 4px;

          /deep/ .el-textarea {
            height: 152px;
            cursor: pointer;
          }

          /deep/ .el-textarea__inner {
            height: 152px;
            padding: 10px 10px 20px;
          }

          /deep/ .el-textarea .el-textarea__inner {
            // 然后找到对应的类名，在这里将拉伸去掉即可
            resize: none;
          }
        }
      }
    }

    .addBlock-div-button {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 24px;
      box-sizing: border-box;
      height: 52px;
      border-top: 1px solid #e9edf4;

      .addBlock-div-button-left,
      .addBlock-div-button-right {
        width: 65px;
        height: 32px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #e9edf4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .addBlock-div-button-right {
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        margin-left: 8px;
        color: #ffffff;
      }
    }
  }
}

// 二级确认
.reminder {
  /deep/ .el-dialog {
    height: 230px;
  }

  /deep/ .el-dialog__footer {
    padding: 25px 0;
    box-sizing: border-box;
  }

  .reminder-div {
    width: 100%;
    text-align: center;
    .reminder-div-img {
      width: 56px;
      height: 56px;
      margin: 0 auto;
    }

    .reminder-div-title {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 8px;
    }

    .reminder-div-button {
      display: flex;
      justify-content: center;
      align-content: center;
      margin-top: 40px;

      .reminder-div-button-left,
      .reminder-div-button-right {
        width: 88px;
        height: 32px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .reminder-div-button-right {
        margin-left: 8px;
        border: 1px solid #e9edf4;
        color: rgba(0, 0, 0, 0.65);
        background: #ffffff;
      }
    }
  }
}

// 删除
.detele {
  /deep/ .el-dialog {
    height: 230px;
  }

  /deep/ .el-dialog__footer {
    padding: 25px 0;
    box-sizing: border-box;
  }

  .detele-div {
    width: 100%;
    text-align: center;
    .detele-div-img {
      width: 56px;
      height: 56px;
      margin: 0 auto;
    }

    .detele-div-title {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 8px;
    }

    .detele-div-button {
      display: flex;
      justify-content: center;
      align-content: center;
      margin-top: 40px;

      .detele-div-button-left,
      .detele-div-button-right {
        width: 88px;
        height: 32px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .detele-div-button-right {
        margin-left: 8px;
        border: 1px solid #e9edf4;
        color: rgba(0, 0, 0, 0.65);
        background: #ffffff;
      }
    }
  }
}
</style>
